module.exports = __webpack_public_path__ + "img/logo.f28a306.png";